import { HandoffMetric } from '../../../../handoff-hub.types';
import { ChecklistMetricItem } from '../handoff-checklist-v2/handoff-checklist-v2.types';
import {
  mapStatusToResult,
  mapResultToStatus,
  deriveOverallStatus,
  mapChecklistMetricsToHandoffMetrics,
  mapSnapshotMetricsToChecklist,
} from '../handoff-checklist-v2/handoff-checklist-v2.helpers';
import { WIE_METRIC_DEFINITIONS } from './wie-metric-definitions';
import { buildPayerListNode, parsePayerListData } from './metrics/wie-payer-message';

export {
  mapStatusToResult,
  mapResultToStatus,
  deriveOverallStatus,
  mapChecklistMetricsToHandoffMetrics,
};

export const mapSnapshotMetricsToWieChecklist = (
  metrics: HandoffMetric[]
): ChecklistMetricItem[] =>
  mapSnapshotMetricsToChecklist(metrics, WIE_METRIC_DEFINITIONS, (m, configCriterion) => {
    const parsed = parsePayerListData(m.actualValue as string);
    return {
      description: m.subsection,
      status: mapResultToStatus(m.result),
      message: m.actualValue as string,
      messageNode: typeof parsed === 'object' ? buildPayerListNode(parsed) : undefined,
      exception: m.exception,
      exceptionType: configCriterion?.exceptionType,
      exceptionOptions: configCriterion?.exceptionOptions,
    };
  });
